import { BusinessType } from './enum'

export const VERIFICATION_APIS: Record<string, BusinessType> = {
  '/transaction/web/tx/create': BusinessType.APPROVE_TRANSACTIONS,
  '/transaction/web/tx/createReplaceTx': BusinessType.APPROVE_TRANSACTIONS,
  '/policy/addressbook/add': BusinessType.ADD_WHITE_ADDRESS,
  '/policy/addressbook/update': BusinessType.EDIT_WHITE_ADDRESS,
}
